// Contenu SEO des pages de services et FAQ locales des pages villes.
// Tous les chiffres et affirmations reprennent des faits déjà publiés sur le site
// (83 % chaleur, protection UV, durabilité 15 ans+, cure 30 jours,
// estimation gratuite 24-48 h, zones Montréal / Rive-Nord / Rive-Sud).

export const serviceCommon = {
  fr: {
    photosEyebrow: "Installations réelles",
    faqEyebrow: "Questions fréquentes",
    ctaEyebrow: "Estimation gratuite",
    ctaTitle: "Estimation gratuite, réponse en 24 à 48 h.",
    ctaText:
      "Un membre de notre équipe évalue vos fenêtres, l'exposition et vos objectifs, puis vous donne un prix clair. Sans engagement.",
    ctaButton: "Obtenir mon estimation gratuite",
    exploreTitle: "Explorez nos autres pellicules",
    areasLine: "Installation à Montréal, sur la Rive-Nord et la Rive-Sud",
  },
  en: {
    photosEyebrow: "Real installations",
    faqEyebrow: "Frequently asked questions",
    ctaEyebrow: "Free estimate",
    ctaTitle: "Free estimate, reply within 24 to 48 h.",
    ctaText:
      "A member of our team assesses your windows, their exposure and your goals, then gives you a clear price. No commitment.",
    ctaButton: "Get my free estimate",
    exploreTitle: "Explore our other films",
    areasLine: "Installation in Montreal, on the North Shore and the South Shore",
  },
};

// Section vidéo YouTube Short « Explication sur nos pellicules ».
// Résumé rédigé d'après le contenu réel de la vidéo (2 types de pellicules,
// miroir pâle/foncé, givrée, 15 ans, 0 bulle, protection UV, prix vs rideaux).
// uploadDate et duration volontairement absents du JSON-LD : à fournir par le client.
export const videoSection = {
  fr: {
    eyebrow: "En vidéo",
    title: "Voyez la pellicule en action.",
    summary:
      "Dans cette courte vidéo, on vous présente nos deux familles de pellicules, pour la résidence comme pour le commerce. La pellicule miroir règle les problèmes d'éblouissement et de température tout en gardant une vision claire vers l'extérieur, offerte en version pâle, discrète et lumineuse, ou foncée, pour une régulation de température et une intimité maximales. La pellicule givrée assure une intimité totale jour et nuit tout en laissant entrer la lumière naturelle : parfaite pour les entrées et les salles de bain. Nos pellicules durent 15 ans, sans bulles ni décollement, et protègent vos planchers et meubles de la décoloration causée par les rayons UV.",
    cta: "Obtenir mon estimation gratuite",
    playLabel: "Lire la vidéo : Explication sur nos pellicules",
    iframeTitle: "Vidéo, Explication sur nos pellicules (Reflectum Pellicule)",
    posterAlt: "Extrait de la vidéo de présentation des pellicules Reflectum, appuyez pour lire",
    videoName: "Explication sur nos pellicules",
  },
  en: {
    eyebrow: "Watch the video",
    title: "See the film in action.",
    summary:
      "In this short video, we present our two families of window films, for homes and businesses alike. Mirror film solves glare and temperature problems while keeping a clear view outside, available in a light version, discreet and bright, or a dark version for maximum temperature regulation and privacy. Frosted film provides total privacy day and night while letting natural light in: perfect for entryways and bathrooms. Our films last 15 years, with no bubbles and no peeling, and they protect your floors and furniture from fading caused by UV rays.",
    cta: "Get my free estimate",
    playLabel: "Play the video: Explication sur nos pellicules",
    iframeTitle: "Video, Explication sur nos pellicules (Reflectum Pellicule)",
    posterAlt: "Frame from the Reflectum window films presentation video, press to play",
    videoName: "Explication sur nos pellicules",
  },
};

export const servicePages = {
  fr: {
    miroir: {
      path: "/pellicule-miroir",
      metaTitle: "Pellicule miroir pour fenêtres | Reflectum Pellicule",
      metaDesc:
        "Pellicule miroir à Montréal : intimité totale de jour, jusqu'à 83 % de chaleur solaire rejetée et une protection contre les UV. Estimation gratuite en 24 h.",
      eyebrow: "Pellicule miroir",
      h1: "Pellicule miroir pour fenêtres : intimité totale de jour.",
      intro:
        "De l'extérieur, vos fenêtres deviennent un miroir élégant : impossible de voir à l'intérieur durant la journée. De l'intérieur, vous gardez une vue claire et lumineuse. C'est la façon la plus simple de bloquer les regards sans rideaux et sans changer vos fenêtres. En prime, la pellicule miroir rejette jusqu'à 83 % de la chaleur solaire et protège contre les rayons UV. Installation professionnelle à Montréal, sur la Rive-Nord et la Rive-Sud.",
      sections: [
        {
          title: "Comment fonctionne l'effet miroir ?",
          text: "L'effet miroir suit une règle simple : il apparaît du côté le plus lumineux. Le jour, la lumière extérieure domine, la pellicule réfléchit la façade et bloque les regards, pendant que vous voyez normalement vers l'extérieur. Le soir, si vos pièces sont éclairées alors qu'il fait noir dehors, l'effet s'inverse : c'est vrai pour toutes les pellicules miroir, et on préfère vous le dire franchement. Tamiser l'éclairage intérieur ou orienter un luminaire extérieur vers les fenêtres aide à préserver l'intimité. Et pour les pièces qui exigent une intimité absolue en tout temps, la pellicule givrée reste la solution jour et nuit.",
        },
        {
          title: "Moins de chaleur, moins d'éblouissement",
          text: "Une pellicule miroir ne sert pas qu'à l'intimité. Elle rejette jusqu'à 83 % de la chaleur solaire avant qu'elle ne traverse le vitrage, un vrai soulagement pendant les canicules, surtout pour les fenêtres exposées plein sud ou plein ouest et les verrières. Elle réduit aussi l'éblouissement de façon marquée : fini les reflets qui rendent les écrans d'ordinateur et les téléviseurs illisibles. Le rendu se compare à une paire de lunettes de soleil pour vos fenêtres : la pièce reste lumineuse, mais nettement plus confortable.",
        },
        {
          title: "Où installer une pellicule miroir ?",
          text: "La pellicule miroir convient particulièrement aux grandes fenêtres et portes vitrées qui donnent sur la rue ou chez les voisins, aux façades plein soleil, aux verrières et solariums qui surchauffent l'été, ainsi qu'aux bureaux et commerces qui veulent protéger leur intimité sans sacrifier la lumière. Nous l'installons dans les résidences, maisons, condos, duplex, comme dans les bâtiments commerciaux. Chaque fenêtre est évaluée avant la pose pour confirmer la compatibilité du vitrage.",
        },
        {
          title: "Une pose propre et soignée",
          text: "Notre service est clé en main : nous mesurons, découpons et posons la pellicule avec une finition propre, sans bulles. La plupart des résidences sont complétées en une seule journée. Après une période de cure d'environ 30 jours, vos vitres s'entretiennent normalement, au chiffon doux avec un nettoyant sans abrasif. Nos pellicules professionnelles durent 15 ans et plus, sans jaunir ni décoller.",
        },
      ],
      images: [
        { src: "/images/miroir-1.webp", w: 923, h: 2000, alt: "Pellicule miroir posée sur une grande fenêtre résidentielle, effet réfléchissant de jour" },
        { src: "/images/miroir-3.webp", w: 2000, h: 1500, alt: "Fenêtres avec pellicule miroir vues de l'extérieur, les regards sont bloqués" },
        { src: "/images/miroir-4.webp", w: 923, h: 2000, alt: "Installation de pellicule miroir sur fenêtre de façade par Reflectum Pellicule" },
      ],
      faq: [
        {
          q: "Est-ce qu'on peut voir à l'intérieur le soir ?",
          a: "Le soir, si vos pièces sont éclairées alors qu'il fait noir à l'extérieur, l'effet miroir s'estompe, c'est le principe de toutes les pellicules miroir. Tamiser l'éclairage intérieur ou orienter un éclairage extérieur vers les fenêtres aide à préserver l'intimité. Pour une tranquillité totale jour et nuit, la pellicule givrée est la bonne solution, ou fermez stores et rideaux le soir.",
        },
        {
          q: "Est-ce que la pellicule miroir assombrit mes pièces ?",
          a: "L'effet se compare à des lunettes de soleil : la lumière entre toujours, mais l'éblouissement et la chaleur sont fortement réduits. De l'intérieur, on peut percevoir un léger reflet bleuté ou argenté selon le modèle, discret au quotidien. Il existe aussi une teinte plus légère qui laisse passer davantage de lumière, avec un effet miroir plus discret.",
        },
        {
          q: "Comment entretenir une pellicule miroir ?",
          a: "Après une période de cure d'environ 30 jours, nettoyez vos fenêtres normalement avec un chiffon doux et un nettoyant sans abrasif. Aucun entretien spécial n'est requis, et la pellicule ne jaunit pas avec le temps.",
        },
        {
          q: "Est-ce compatible avec mes fenêtres thermos ?",
          a: "Ça dépend du type de vitrage : sur certains verres, une pellicule solaire peut créer un risque de choc thermique. C'est pourquoi nous évaluons la compatibilité de chaque fenêtre avant la pose, et nous vous informons de tout risque avant de commencer.",
        },
      ],
    },
    "anti-chaleur": {
      path: "/pellicule-anti-chaleur",
      metaTitle: "Pellicule anti-chaleur pour fenêtres | Reflectum Pellicule",
      metaDesc:
        "Pellicule anti-chaleur à Montréal : jusqu'à 83 % de la chaleur solaire rejetée par vos fenêtres existantes, sans les remplacer. Estimation gratuite en 24 h.",
      eyebrow: "Pellicule anti-chaleur",
      h1: "Pellicule anti-chaleur : jusqu'à 83 % de chaleur solaire rejetée.",
      intro:
        "L'été, le vitrage agit comme une serre : le soleil entre, la chaleur reste. La pellicule anti-chaleur se pose directement sur vos fenêtres existantes et rejette jusqu'à 83 % de la chaleur solaire avant qu'elle ne pénètre dans la pièce. Résultat : des pièces nettement plus confortables pendant les canicules, sans remplacer vos fenêtres et sans bloquer la lumière. Installation professionnelle à Montréal, sur la Rive-Nord et la Rive-Sud.",
      sections: [
        {
          title: "Pourquoi certaines pièces deviennent invivables l'été",
          text: "Les fenêtres exposées plein sud ou plein ouest, les verrières, les solariums et les portes-patio laissent entrer une énorme quantité de rayonnement solaire. La chaleur s'accumule, la climatisation tourne sans arrêt et certaines pièces deviennent inutilisables en après-midi. Remplacer les fenêtres coûte cher, souvent 15 000 $ et plus pour une résidence. La pellicule anti-chaleur s'attaque au problème à la source, pour une fraction du prix.",
        },
        {
          title: "Comment la pellicule bloque-t-elle la chaleur ?",
          text: "La pellicule réfléchit une partie du rayonnement solaire vers l'extérieur avant qu'il ne traverse le verre. Selon le film choisi, l'énergie solaire totale rejetée atteint environ 63 à 83 %, nos pellicules miroir haute performance montent jusqu'à 83 % de chaleur rejetée. Elles offrent en prime une protection contre les rayons UV et réduisent l'éblouissement de 62 à 82 %, selon la teinte. Nous vous aidons à choisir le bon niveau de performance selon l'orientation et l'usage de chaque pièce.",
        },
        {
          title: "Concret au quotidien",
          text: "Dès la pose, la différence se sent : les pièces exposées au soleil restent agréables en après-midi, les écrans d'ordinateur et les téléviseurs redeviennent lisibles sans fermer les rideaux, et la lumière naturelle est toujours au rendez-vous. C'est aussi une protection pour votre intérieur : la pellicule protège contre les rayons UV et aide à prévenir la décoloration des planchers, des meubles et des rideaux.",
        },
        {
          title: "Résidentiel et commercial",
          text: "Nous installons des pellicules anti-chaleur dans les maisons, condos et duplex, mais aussi dans les bureaux, commerces et bâtiments professionnels. Pour les espaces de travail, la pose peut être planifiée hors de vos heures d'ouverture pour ne pas déranger vos opérations. Chaque projet commence par une estimation gratuite : on mesure, on évalue l'exposition, puis on vous donne un prix clair, sans engagement.",
        },
      ],
      images: [
        { src: "/images/vue-interieure.webp", w: 923, h: 2000, alt: "Vue depuis l'intérieur, la lumière traverse la pellicule anti-chaleur posée sur la fenêtre" },
        { src: "/images/residentiel.webp", w: 1600, h: 2400, alt: "Résidence dont les fenêtres exposées au soleil sont équipées d'une pellicule anti-chaleur" },
        { src: "/images/miroir-3.webp", w: 2000, h: 1500, alt: "Grande fenêtre résidentielle avec pellicule solaire anti-chaleur réfléchissante" },
      ],
      faq: [
        {
          q: "Est-ce que la pellicule anti-chaleur assombrit les pièces ?",
          a: "L'effet se compare à des lunettes de soleil : la lumière naturelle entre toujours, mais la chaleur et l'éblouissement sont fortement réduits. Il existe plusieurs niveaux de teinte, une version plus légère laisse passer davantage de lumière, avec une protection thermique plus modérée. On vous conseille selon l'orientation de vos fenêtres.",
        },
        {
          q: "Est-ce compatible avec les fenêtres thermos ?",
          a: "Ça dépend du type de vitrage : sur certains verres, une pellicule solaire peut créer un risque de choc thermique. Nous évaluons la compatibilité de chaque fenêtre avant la pose, et nous vous informons de tout risque avant de commencer.",
        },
        {
          q: "Combien de temps prend l'installation ?",
          a: "La plupart des résidences sont complétées en une seule journée. Pour les commerces et bureaux, on planifie la pose hors de vos heures d'ouverture pour ne pas déranger vos opérations.",
        },
        {
          q: "Quelle est la durée de vie de la pellicule ?",
          a: "Nos pellicules professionnelles durent 15 ans et plus : elles ne jaunissent pas, ne bullent pas et ne décollent pas.",
        },
      ],
    },
    "anti-uv": {
      path: "/pellicule-anti-uv",
      metaTitle: "Pellicule anti-UV pour fenêtres | Reflectum Pellicule",
      metaDesc:
        "Pellicule anti-UV à Montréal : une protection contre les rayons UV pour préserver planchers, meubles et rideaux de la décoloration. Estimation gratuite.",
      eyebrow: "Pellicule anti-UV",
      h1: "Pellicule anti-UV pour fenêtres : protection contre les rayons UV.",
      intro:
        "Les rayons ultraviolets traversent le verre et abîment lentement tout ce qu'ils touchent : planchers de bois qui pâlissent, tissus qui décolorent, meubles qui ternissent. Nos pellicules pour fenêtres offrent une protection contre les rayons UV tout en laissant passer la lumière naturelle. C'est une protection discrète et permanente, posée sur vos fenêtres existantes, à Montréal, sur la Rive-Nord et la Rive-Sud.",
      sections: [
        {
          title: "Ce que les UV font à votre intérieur",
          text: "Le soleil qui entre par les fenêtres est le premier responsable de la décoloration des intérieurs. Les planchers pâlissent par bandes là où le soleil frappe, les rideaux et les tapis perdent leurs couleurs, les meubles vieillissent avant le temps. Une fois la décoloration installée, impossible de revenir en arrière. La pellicule anti-UV agit en prévention, tous les jours, sans que vous ayez à y penser.",
        },
        {
          title: "Une protection permanente, sans aucun geste",
          text: "Contrairement aux rideaux et aux stores, qu'il faut fermer, et qui bloquent aussi la lumière et la vue, la pellicule filtre les UV en continu. Nos deux gammes, miroir et givrée, offrent une protection contre les rayons UV : vous choisissez l'effet d'intimité que vous préférez, la protection UV vient avec. Dans sa version miroir haute performance, la pellicule rejette aussi jusqu'à 83 % de la chaleur solaire.",
        },
        {
          title: "Pour la maison comme pour le commerce",
          text: "À la maison, la pellicule anti-UV protège les pièces les plus exposées : salon plein sud, salle à manger ensoleillée, escalier près d'une grande fenêtre. Côté commercial, elle protège la marchandise en vitrine, le mobilier de bureau et les espaces d'accueil. L'installation est propre et rapide, la plupart des résidences sont complétées en une seule journée, sans poussière ni dégât.",
        },
        {
          title: "Pose professionnelle et soignée",
          text: "Nous mesurons, découpons et posons chaque pellicule avec une finition soignée, sans bulles. Après une cure d'environ 30 jours, l'entretien se fait normalement, au chiffon doux avec un nettoyant sans abrasif. Nos pellicules professionnelles durent 15 ans et plus sans jaunir ni décoller.",
        },
      ],
      images: [
        { src: "/images/miroir-2.webp", w: 923, h: 2000, alt: "Pellicule anti-UV posée sur une grande fenêtre, intérieur protégé des rayons du soleil" },
        { src: "/images/vue-exterieure.webp", w: 923, h: 2000, alt: "Fenêtre résidentielle vue de l'extérieur avec pellicule protectrice anti-UV" },
        { src: "/images/givre-1.webp", w: 923, h: 2000, alt: "Pellicule givrée anti-UV sur fenêtre, fini dépoli qui laisse passer la lumière" },
      ],
      faq: [
        {
          q: "Est-ce que la pellicule anti-UV change l'apparence de mes fenêtres ?",
          a: "Vous avez le choix entre deux rendus : la pellicule miroir, qui donne un effet réfléchissant de l'extérieur le jour, et la pellicule givrée, au fini dépoli. Dans les deux cas, la vue et la lumière sont préservées de l'intérieur, et la protection contre les UV est incluse.",
        },
        {
          q: "Qu'est-ce que la pellicule protège exactement ?",
          a: "Grâce à sa protection contre les rayons UV, la pellicule aide à prévenir la décoloration des planchers, des meubles, des rideaux et des tapis exposés au soleil. Dans sa version miroir, elle réduit aussi fortement la chaleur et l'éblouissement.",
        },
        {
          q: "Est-ce que ça bloque aussi la chaleur ?",
          a: "Oui, dans sa version miroir : jusqu'à 83 % de la chaleur solaire est rejetée avant d'entrer dans la pièce. C'est un deuxième bénéfice appréciable pendant les canicules, sans aucun geste de votre part.",
        },
        {
          q: "Combien de temps la protection dure-t-elle ?",
          a: "Nos pellicules professionnelles durent 15 ans et plus sans jaunir ni décoller. Si quoi que ce soit ne vous satisfait pas après la pose, on corrige sans frais.",
        },
      ],
    },
    intimite: {
      path: "/pellicule-intimite-fenetre",
      metaTitle: "Pellicule d'intimité pour fenêtres | Reflectum Pellicule",
      metaDesc:
        "Pellicule d'intimité à Montréal : effet miroir le jour ou fini givré jour et nuit. Bloquez les regards sans perdre la lumière. Estimation gratuite en 24 h.",
      eyebrow: "Pellicule d'intimité",
      h1: "Pellicule d'intimité pour fenêtres : bloquez les regards, gardez la lumière.",
      intro:
        "Fenêtre qui donne sur la rue, voisins trop proches, passants curieux : une pellicule d'intimité règle le problème sans rideaux ni stores. Deux familles existent chez Reflectum : la pellicule miroir, qui bloque les regards de jour tout en gardant votre vue, et la pellicule givrée, qui assure une intimité totale jour et nuit en laissant passer la lumière. On vous aide à choisir la bonne, pièce par pièce. Installation à Montréal, sur la Rive-Nord et la Rive-Sud.",
      sections: [
        {
          title: "Deux familles, deux façons de se protéger",
          text: "La pellicule miroir crée un effet réfléchissant vu de l'extérieur : personne ne voit à l'intérieur durant la journée, pendant que vous profitez d'une vue claire. Elle rejette en prime jusqu'à 83 % de la chaleur solaire et protège contre les rayons UV. La pellicule givrée, elle, donne au verre un fini dépoli : la lumière traverse, mais les regards sont bloqués en permanence, c'est la seule des deux qui protège aussi bien la nuit que le jour.",
        },
        {
          title: "La règle jour-nuit, expliquée franchement",
          text: "L'effet miroir dépend de la lumière : il fonctionne tant qu'il fait plus clair à l'extérieur qu'à l'intérieur. Le soir, dans une pièce éclairée, l'effet s'inverse, c'est vrai pour toutes les pellicules miroir. Tamiser l'éclairage intérieur ou éclairer l'extérieur vers les fenêtres aide à préserver l'intimité. Si une pièce exige une intimité absolue en tout temps, la pellicule givrée est la solution : son fini dépoli masque les regards 24 h sur 24.",
        },
        {
          title: "Quelle pellicule pour quelle pièce ?",
          text: "Salon, cuisine ou bureau face à la rue, où vous voulez garder la vue de jour : la pellicule miroir est idéale. Salle de bain, porte d'entrée vitrée, chambre au rez-de-chaussée, cloison de bureau, clinique ou vitrine, où l'intimité doit être permanente : la pellicule givrée s'impose. Dans une même maison, on combine souvent les deux, chaque fenêtre reçoit la pellicule adaptée à sa pièce et à son orientation.",
        },
        {
          title: "Pose clé en main et soignée",
          text: "Notre équipe mesure, découpe et pose chaque pellicule avec une finition propre et sans bulles. La plupart des résidences sont complétées en une seule journée. Après une cure d'environ 30 jours, l'entretien se fait normalement, au chiffon doux. Nos pellicules professionnelles durent 15 ans et plus.",
        },
      ],
      images: [
        { src: "/images/miroir-4.webp", w: 923, h: 2000, alt: "Pellicule d'intimité à effet miroir sur des fenêtres de façade, regards bloqués de jour" },
        { src: "/images/givre-1.webp", w: 923, h: 2000, alt: "Pellicule d'intimité givrée sur fenêtre, fini dépoli lumineux jour et nuit" },
        { src: "/images/givre-2.webp", w: 923, h: 2000, alt: "Fenêtre équipée d'une pellicule d'intimité givrée installée par Reflectum Pellicule" },
      ],
      faq: [
        {
          q: "Le soir, est-ce qu'on voit à l'intérieur avec la pellicule miroir ?",
          a: "Si la pièce est éclairée et qu'il fait noir dehors, l'effet miroir s'estompe : c'est le principe de toutes les pellicules miroir. Tamiser l'éclairage ou fermer stores et rideaux le soir règle le problème. Pour une intimité totale jour et nuit, choisissez la pellicule givrée.",
        },
        {
          q: "La pellicule givrée laisse-t-elle passer la lumière ?",
          a: "Oui. Son fini dépoli laisse passer la lumière naturelle tout en masquant les regards, jour et nuit. La pièce reste lumineuse, seule la visibilité à travers le verre est bloquée.",
        },
        {
          q: "Peut-on combiner miroir et givrée dans une même maison ?",
          a: "Oui, et c'est souvent ce qu'on recommande : miroir pour les pièces de vie où vous voulez garder la vue de jour, givrée pour la salle de bain, l'entrée ou la chambre. Chaque fenêtre est évaluée séparément lors de l'estimation gratuite.",
        },
        {
          q: "Comment entretenir une pellicule d'intimité ?",
          a: "Après une cure d'environ 30 jours, nettoyez vos fenêtres normalement avec un chiffon doux et un nettoyant sans abrasif. Aucun entretien spécial n'est requis, et la pellicule dure 15 ans et plus.",
        },
      ],
    },
    givree: {
      path: "/pellicule-givree",
      metaTitle: "Pellicule givrée pour fenêtres | Reflectum Pellicule",
      metaDesc:
        "Pellicule givrée à Montréal : intimité jour et nuit avec un fini dépoli qui laisse passer la lumière. Salles de bain, bureaux, vitrines. Estimation gratuite.",
      eyebrow: "Pellicule givrée",
      h1: "Pellicule givrée pour fenêtres : intimité jour et nuit, lumière préservée.",
      intro:
        "La pellicule givrée donne à votre verre un fini dépoli élégant : la lumière naturelle traverse, mais les regards ne passent plus, ni le jour, ni la nuit. C'est la solution idéale là où l'intimité doit être absolue en tout temps, sans rideaux et sans assombrir la pièce. Installation professionnelle à Montréal, sur la Rive-Nord et la Rive-Sud.",
      sections: [
        {
          title: "Un fini dépoli élégant et discret",
          text: "La pellicule givrée diffuse la lumière au lieu de la bloquer : la pièce reste lumineuse, mais les formes et les détails deviennent illisibles de l'autre côté du verre. Le rendu est moderne et épuré, un design discret qui s'intègre à tous les styles, du condo contemporain au bureau professionnel. Elle masque aussi ce que vous ne voulez plus voir : un mur mitoyen, une cour encombrée, une vue peu inspirante.",
        },
        {
          title: "Où la pellicule givrée excelle",
          text: "C'est la pellicule des salles de bain, des portes d'entrée vitrées et des chambres au rez-de-chaussée, partout où l'intimité doit tenir jour et nuit. Côté commercial, elle équipe les cloisons de bureaux, les salles de réunion, les cliniques et les vitrines : elle crée des zones privées tout en gardant les espaces lumineux. Elle peut aussi couvrir seulement une partie d'une fenêtre, selon vos besoins.",
        },
        {
          title: "Givrée ou miroir : laquelle choisir ?",
          text: "La pellicule miroir garde votre vue vers l'extérieur le jour et rejette jusqu'à 83 % de la chaleur solaire, mais son effet s'inverse la nuit dans une pièce éclairée. La pellicule givrée protège en permanence, sans condition de lumière, en échange, on ne voit plus au travers. La règle simple : pour garder la vue, choisissez le miroir ; pour une intimité absolue jour et nuit, choisissez le givré. Dans une même maison, les deux se combinent très bien.",
        },
        {
          title: "Une pose propre et soignée",
          text: "Notre service est clé en main : mesure, découpe et pose avec une finition sans bulles, en une seule journée pour la plupart des résidences. Après une cure d'environ 30 jours, l'entretien se fait normalement, au chiffon doux. Nos pellicules professionnelles durent 15 ans et plus sans jaunir ni décoller.",
        },
      ],
      images: [
        { src: "/images/givre-hero.webp", w: 2000, h: 1091, alt: "Pellicule givrée posée sur de grandes fenêtres, fini dépoli élégant et lumineux" },
        { src: "/images/givre-2.webp", w: 923, h: 2000, alt: "Fenêtre avec pellicule givrée, intimité préservée dans une pièce lumineuse" },
        { src: "/images/givre-3.webp", w: 923, h: 2000, alt: "Installation de pellicule givrée sur vitrage par Reflectum Pellicule" },
      ],
      faq: [
        {
          q: "La pellicule givrée laisse-t-elle vraiment passer la lumière ?",
          a: "Oui. C'est sa grande force : le fini dépoli diffuse la lumière naturelle au lieu de la bloquer. La pièce reste lumineuse, seuls les regards sont arrêtés, jour et nuit.",
        },
        {
          q: "Peut-on distinguer des silhouettes à travers ?",
          a: "Tout près du verre, on peut percevoir une ombre floue en mouvement, jamais de détails nets. C'est ce qui rend la pellicule givrée parfaite pour les salles de bain et les portes d'entrée.",
        },
        {
          q: "Quelle est la différence avec un vrai verre dépoli ?",
          a: "La pellicule donne le même effet dépoli sur vos fenêtres existantes, sans remplacer le verre, pour une fraction du prix d'un remplacement, et avec une pose propre en une journée pour la plupart des résidences.",
        },
        {
          q: "Comment l'entretenir ?",
          a: "Après une cure d'environ 30 jours, nettoyez normalement avec un chiffon doux et un nettoyant sans abrasif. La pellicule dure 15 ans et plus.",
        },
      ],
    },
  },
  en: {
    miroir: {
      path: "/pellicule-miroir",
      metaTitle: "Mirror Window Film for Privacy | Reflectum Pellicule",
      metaDesc:
        "Mirror window film installed in Montreal: total daytime privacy, up to 83% of solar heat rejected and UV protection. Free estimate in 24 h.",
      eyebrow: "Mirror window film",
      h1: "Mirror window film: total daytime privacy.",
      intro:
        "From the outside, your windows become an elegant mirror: no one can see in during the day. From the inside, you keep a clear, bright view. It's the simplest way to block prying eyes without curtains and without replacing your windows. As a bonus, mirror film rejects up to 83% of solar heat and protects against UV rays. Professional installation in Montreal, on the North Shore and the South Shore.",
      sections: [
        {
          title: "How does the mirror effect work?",
          text: "The mirror effect follows a simple rule: it appears on the brighter side. By day, outdoor light dominates, the film reflects the facade and blocks gazes, while you see outside normally. In the evening, if your rooms are lit while it's dark outside, the effect reverses: that's true of every mirror film, and we'd rather tell you upfront. Dimming indoor lights or aiming an outdoor light at the windows helps preserve privacy. And for rooms that need absolute privacy at all times, frosted film is the day-and-night solution.",
        },
        {
          title: "Less heat, less glare",
          text: "Mirror film does more than privacy. It rejects up to 83% of solar heat before it crosses the glass, real relief during heat waves, especially for south- or west-facing windows and glass roofs. It also cuts glare dramatically: no more reflections making computer screens and TVs unreadable. The result is like sunglasses for your windows: the room stays bright, but far more comfortable.",
        },
        {
          title: "Where should mirror film be installed?",
          text: "Mirror film is ideal for large windows and glass doors facing the street or the neighbours, sun-drenched facades, verandas and solariums that overheat in summer, and offices or shops that want privacy without giving up natural light. We install it in homes, houses, condos, duplexes, and in commercial buildings alike. Every window is assessed before installation to confirm glazing compatibility.",
        },
        {
          title: "A clean, careful install",
          text: "Our service is turnkey: we measure, cut and apply the film with a clean, bubble-free finish. Most homes are completed in a single day. After a curing period of about 30 days, your glass is cleaned as usual, with a soft cloth and a non-abrasive cleaner. Our professional films last 15 years and more without yellowing or peeling.",
        },
      ],
      images: [
        { src: "/images/miroir-1.webp", w: 923, h: 2000, alt: "Mirror film applied to a large residential window, daytime reflective effect" },
        { src: "/images/miroir-3.webp", w: 2000, h: 1500, alt: "Windows with mirror film seen from outside, gazes are blocked" },
        { src: "/images/miroir-4.webp", w: 923, h: 2000, alt: "Mirror window film installed on a facade window by Reflectum Pellicule" },
      ],
      faq: [
        {
          q: "Can people see inside in the evening?",
          a: "In the evening, if your rooms are lit while it's dark outside, the mirror effect fades, that's how every mirror film works. Dimming indoor lights or aiming outdoor lighting at the windows helps. For total day-and-night privacy, frosted film is the right choice, or close blinds and curtains at night.",
        },
        {
          q: "Does mirror film darken my rooms?",
          a: "The effect is like sunglasses: light still comes in, but glare and heat are greatly reduced. From inside, you may notice a slight bluish or silvery reflection depending on the model, subtle in everyday life. A lighter shade is also available, letting in more light with a more discreet mirror effect.",
        },
        {
          q: "How do I maintain mirror film?",
          a: "After a curing period of about 30 days, clean your windows as usual with a soft cloth and a non-abrasive cleaner. No special maintenance is needed, and the film won't yellow over time.",
        },
        {
          q: "Is it compatible with my sealed (thermal) windows?",
          a: "It depends on the glazing: on some glass types, a solar film can create a thermal stress risk. That's why we assess every window's compatibility before installation, and we tell you about any risk before we start.",
        },
      ],
    },
    "anti-chaleur": {
      path: "/pellicule-anti-chaleur",
      metaTitle: "Solar Heat Control Window Film | Reflectum Pellicule",
      metaDesc:
        "Heat-control window film in Montreal: reject up to 83% of solar heat through your existing windows, without replacing them. Free estimate in 24 h.",
      eyebrow: "Heat control film",
      h1: "Heat control window film: reject up to 83% of solar heat.",
      intro:
        "In summer, glass acts like a greenhouse: sunlight comes in, the heat stays. Heat control film applies directly to your existing windows and rejects up to 83% of solar heat before it enters the room. The result: noticeably more comfortable rooms during heat waves, without replacing your windows and without blocking the light. Professional installation in Montreal, on the North Shore and the South Shore.",
      sections: [
        {
          title: "Why some rooms become unlivable in summer",
          text: "South- and west-facing windows, glass roofs, solariums and patio doors let in a huge amount of solar radiation. Heat builds up, the air conditioner runs non-stop and some rooms become unusable in the afternoon. Replacing windows is expensive, often $15,000 or more for a home. Heat control film tackles the problem at the source, for a fraction of the price.",
        },
        {
          title: "How does the film block heat?",
          text: "The film reflects part of the solar radiation back outside before it crosses the glass. Depending on the film chosen, total solar energy rejected reaches about 63 to 83%, our high-performance mirror films go up to 83% heat rejection. They also protect against UV rays and cut glare by 62 to 82%, depending on the shade. We help you pick the right performance level for each room's orientation and use.",
        },
        {
          title: "What changes day to day",
          text: "From the moment it's installed, you feel the difference: sun-exposed rooms stay pleasant in the afternoon, computer screens and TVs are readable again without closing the curtains, and natural light is still there. It also protects your interior: its UV protection helps prevent fading of floors, furniture and curtains.",
        },
        {
          title: "Residential and commercial",
          text: "We install heat control films in houses, condos and duplexes, but also in offices, shops and professional buildings. For workplaces, installation can be scheduled outside your opening hours so your operations are never disrupted. Every project starts with a free estimate: we measure, assess the exposure, then give you a clear price, no commitment.",
        },
      ],
      images: [
        { src: "/images/vue-interieure.webp", w: 923, h: 2000, alt: "View from inside, light passes through the heat control film applied to the window" },
        { src: "/images/residentiel.webp", w: 1600, h: 2400, alt: "Home whose sun-exposed windows are fitted with heat control film" },
        { src: "/images/miroir-3.webp", w: 2000, h: 1500, alt: "Large residential window with reflective solar heat control film" },
      ],
      faq: [
        {
          q: "Does heat control film darken rooms?",
          a: "The effect is like sunglasses: natural light still comes in, but heat and glare are greatly reduced. Several shade levels exist, a lighter version lets in more light with more moderate thermal protection. We advise you based on your windows' orientation.",
        },
        {
          q: "Is it compatible with sealed (thermal) windows?",
          a: "It depends on the glazing: on some glass types, a solar film can create a thermal stress risk. We assess every window's compatibility before installation, and we tell you about any risk before we start.",
        },
        {
          q: "How long does installation take?",
          a: "Most homes are completed in a single day. For shops and offices, we schedule the work outside your opening hours so your operations are not disrupted.",
        },
        {
          q: "How long does the film last?",
          a: "Our professional films last 15 years and more: they don't yellow, bubble or peel.",
        },
      ],
    },
    "anti-uv": {
      path: "/pellicule-anti-uv",
      metaTitle: "UV Protection Window Film | Reflectum Pellicule",
      metaDesc:
        "UV-blocking window film in Montreal: protection against UV rays to preserve floors, furniture and curtains from fading. Free estimate in 24 h.",
      eyebrow: "UV protection film",
      h1: "UV protection window film: protect your interior from the sun.",
      intro:
        "Ultraviolet rays pass through glass and slowly damage everything they touch: hardwood floors that fade, fabrics that discolour, furniture that dulls. Our window films protect against UV rays while letting natural light through. It's a discreet, permanent protection, applied to your existing windows, in Montreal, on the North Shore and the South Shore.",
      sections: [
        {
          title: "What UV does to your interior",
          text: "Sunlight coming through windows is the number one cause of interior fading. Floors pale in bands where the sun hits, curtains and rugs lose their colours, furniture ages before its time. Once fading sets in, there's no going back. UV protection film works preventively, every day, without you having to think about it.",
        },
        {
          title: "Permanent protection, zero effort",
          text: "Unlike curtains and blinds, which you have to close, blocking light and view too, the film filters UV continuously. Both our ranges, mirror and frosted, protect against UV rays: you pick the privacy style you prefer, the UV protection comes with it. In its high-performance mirror version, the film also rejects up to 83% of solar heat.",
        },
        {
          title: "For homes and businesses alike",
          text: "At home, UV film protects your most exposed rooms: the south-facing living room, the sunny dining room, the staircase beside a large window. On the commercial side, it protects storefront merchandise, office furniture and reception areas. Installation is clean and fast, most homes are completed in a single day, with no dust and no mess.",
        },
        {
          title: "Professional, careful installation",
          text: "We measure, cut and apply each film with a careful, bubble-free finish. After a curing period of about 30 days, cleaning is done as usual with a soft cloth and non-abrasive cleaner. Our professional films last 15 years and more without yellowing or peeling.",
        },
      ],
      images: [
        { src: "/images/miroir-2.webp", w: 923, h: 2000, alt: "UV protection film applied to a large window, interior shielded from sun rays" },
        { src: "/images/vue-exterieure.webp", w: 923, h: 2000, alt: "Residential window seen from outside with UV protective film" },
        { src: "/images/givre-1.webp", w: 923, h: 2000, alt: "Frosted UV protection film on a window, matte finish that lets light through" },
      ],
      faq: [
        {
          q: "Does UV film change how my windows look?",
          a: "You choose between two finishes: mirror film, which gives a reflective look from outside by day, or frosted film, with a matte finish. In both cases, the view and the light are preserved from inside, with built-in UV protection.",
        },
        {
          q: "What exactly does the film protect?",
          a: "Its UV protection helps prevent fading of floors, furniture, curtains and rugs exposed to the sun. In its mirror version, it also strongly reduces heat and glare.",
        },
        {
          q: "Does it block heat too?",
          a: "Yes, in its mirror version: up to 83% of solar heat is rejected before entering the room. A welcome second benefit during heat waves, with no effort on your part.",
        },
        {
          q: "How long does the protection last?",
          a: "Our professional films last 15 years and more without yellowing or peeling. If anything doesn't satisfy you after the installation, we fix it at no cost.",
        },
      ],
    },
    intimite: {
      path: "/pellicule-intimite-fenetre",
      metaTitle: "Privacy Window Film for Homes | Reflectum Pellicule",
      metaDesc:
        "Privacy window film in Montreal: daytime mirror effect or frosted day-and-night privacy that keeps natural light. Homes and businesses. Free estimate.",
      eyebrow: "Privacy window film",
      h1: "Privacy window film: block the gazes, keep the light.",
      intro:
        "A window facing the street, neighbours too close, curious passersby: a privacy film solves the problem without curtains or blinds. Two families exist at Reflectum: mirror film, which blocks gazes by day while keeping your view, and frosted film, which provides total privacy day and night while letting light through. We help you pick the right one, room by room. Installation in Montreal, on the North Shore and the South Shore.",
      sections: [
        {
          title: "Two families, two ways to protect yourself",
          text: "Mirror film creates a reflective look from outside: no one sees in during the day, while you enjoy a clear view. As a bonus, it rejects up to 83% of solar heat and protects against UV rays. Frosted film gives glass a matte finish: light passes through, but gazes are permanently blocked, it's the only one of the two that protects at night as well as by day.",
        },
        {
          title: "The day-night rule, explained honestly",
          text: "The mirror effect depends on light: it works as long as it's brighter outside than inside. In the evening, in a lit room, the effect reverses, that's true of every mirror film. Dimming indoor lights or lighting the outside toward the windows helps preserve privacy. If a room needs absolute privacy at all times, frosted film is the answer: its matte finish blocks gazes 24 hours a day.",
        },
        {
          title: "Which film for which room?",
          text: "Living room, kitchen or office facing the street, where you want to keep the daytime view: mirror film is ideal. Bathroom, glazed front door, ground-floor bedroom, office partition, clinic or storefront, where privacy must be permanent: frosted film is the way to go. In the same home, we often combine both, each window gets the film suited to its room and orientation.",
        },
        {
          title: "Turnkey, careful installation",
          text: "Our team measures, cuts and applies each film with a clean, bubble-free finish. Most homes are completed in a single day. After a curing period of about 30 days, cleaning is done as usual with a soft cloth. Our professional films last 15 years and more.",
        },
      ],
      images: [
        { src: "/images/miroir-4.webp", w: 923, h: 2000, alt: "Mirror-effect privacy film on facade windows, daytime gazes blocked" },
        { src: "/images/givre-1.webp", w: 923, h: 2000, alt: "Frosted privacy film on a window, bright matte finish, day and night" },
        { src: "/images/givre-2.webp", w: 923, h: 2000, alt: "Window fitted with frosted privacy film installed by Reflectum Pellicule" },
      ],
      faq: [
        {
          q: "In the evening, can people see inside with mirror film?",
          a: "If the room is lit and it's dark outside, the mirror effect fades: that's how every mirror film works. Dimming the lights or closing blinds and curtains at night solves it. For total day-and-night privacy, choose frosted film.",
        },
        {
          q: "Does frosted film let light through?",
          a: "Yes. Its matte finish lets natural light through while blocking gazes, day and night. The room stays bright, only visibility through the glass is blocked.",
        },
        {
          q: "Can mirror and frosted films be combined in one home?",
          a: "Yes, and that's often what we recommend: mirror for living areas where you want to keep the daytime view, frosted for the bathroom, entryway or bedroom. Every window is assessed separately during the free estimate.",
        },
        {
          q: "How do I maintain privacy film?",
          a: "After a curing period of about 30 days, clean your windows as usual with a soft cloth and a non-abrasive cleaner. No special maintenance is needed, and the film lasts 15 years and more.",
        },
      ],
    },
    givree: {
      path: "/pellicule-givree",
      metaTitle: "Frosted Window Film, Day & Night | Reflectum Pellicule",
      metaDesc:
        "Frosted window film in Montreal: day-and-night privacy with a soft matte finish that lets natural light through. Bathrooms, offices, storefronts. Free estimate.",
      eyebrow: "Frosted window film",
      h1: "Frosted window film: day-and-night privacy, light preserved.",
      intro:
        "Frosted film gives your glass an elegant matte finish: natural light passes through, but gazes don't, neither by day nor by night. It's the ideal solution wherever privacy must be absolute at all times, without curtains and without darkening the room. Professional installation in Montreal, on the North Shore and the South Shore.",
      sections: [
        {
          title: "An elegant, discreet matte finish",
          text: "Frosted film diffuses light instead of blocking it: the room stays bright, but shapes and details become unreadable from the other side of the glass. The look is modern and clean, a discreet design that fits every style, from contemporary condos to professional offices. It also hides what you no longer want to see: a shared wall, a cluttered yard, an uninspiring view.",
        },
        {
          title: "Where frosted film shines",
          text: "It's the film for bathrooms, glazed front doors and ground-floor bedrooms, anywhere privacy must hold day and night. On the commercial side, it equips office partitions, meeting rooms, clinics and storefronts: it creates private zones while keeping spaces bright. It can also cover only part of a window, depending on your needs.",
        },
        {
          title: "Frosted or mirror: which one to choose?",
          text: "Mirror film keeps your outward view by day and rejects up to 83% of solar heat, but its effect reverses at night in a lit room. Frosted film protects permanently, with no light condition, in exchange, you can no longer see through. The simple rule: to keep the view, choose mirror; for absolute day-and-night privacy, choose frosted. In the same home, the two combine very well.",
        },
        {
          title: "A clean, careful install",
          text: "Our service is turnkey: measuring, cutting and application with a bubble-free finish, in a single day for most homes. After a curing period of about 30 days, cleaning is done as usual with a soft cloth. Our professional films last 15 years and more without yellowing or peeling.",
        },
      ],
      images: [
        { src: "/images/givre-hero.webp", w: 2000, h: 1091, alt: "Frosted film applied to large windows, elegant, bright matte finish" },
        { src: "/images/givre-2.webp", w: 923, h: 2000, alt: "Window with frosted film, privacy preserved in a bright room" },
        { src: "/images/givre-3.webp", w: 923, h: 2000, alt: "Frosted film installation on glazing by Reflectum Pellicule" },
      ],
      faq: [
        {
          q: "Does frosted film really let light through?",
          a: "Yes. That's its greatest strength: the matte finish diffuses natural light instead of blocking it. The room stays bright, only gazes are stopped, day and night.",
        },
        {
          q: "Can silhouettes be seen through it?",
          a: "Very close to the glass, a blurry moving shadow can be perceived, never sharp details. That's what makes frosted film perfect for bathrooms and front doors.",
        },
        {
          q: "What's the difference from real frosted glass?",
          a: "The film gives the same frosted effect on your existing windows, without replacing the glass, for a fraction of the price of a replacement, with a clean one-day installation for most homes.",
        },
        {
          q: "How do I maintain it?",
          a: "After a curing period of about 30 days, clean as usual with a soft cloth and a non-abrasive cleaner. The film lasts 15 years and more.",
        },
      ],
    },
  },
};

// FAQ locales pour les pages villes (visibles sur la page + JSON-LD FAQPage).
export const cityFaq = {
  fr: {
    laval: [
      {
        q: "Desservez-vous tous les quartiers de Laval ?",
        a: "Oui, nous installons partout à Laval, bungalows, condos, propriétés riveraines et commerces. L'estimation est gratuite et sans engagement, partout en ville.",
      },
      {
        q: "Intervenez-vous dans les copropriétés ?",
        a: "Oui. Nous installons dans les condos comme dans les maisons. Chaque fenêtre est évaluée avant la pose pour confirmer la compatibilité du vitrage, et notre service clé en main est propre et sans dégât.",
      },
      {
        q: "Quelle pellicule pour une maison qui surchauffe l'été ?",
        a: "La pellicule miroir rejette jusqu'à 83 % de la chaleur solaire et protège contre les rayons UV, tout en gardant la lumière. On évalue l'exposition de chaque fenêtre lors de l'estimation gratuite pour choisir la bonne teinte.",
      },
    ],
    longueuil: [
      {
        q: "L'estimation à Longueuil est-elle gratuite ?",
        a: "Oui, partout à Longueuil : vous remplissez le formulaire ou vous nous appelez, et un membre de l'équipe vous répond sous 24 à 48 heures avec un prix clair, sans engagement.",
      },
      {
        q: "Travaillez-vous aussi pour les commerces de Longueuil ?",
        a: "Oui, résidentiel et commercial. Pour les commerces et les bureaux, la pose peut être planifiée hors de vos heures d'ouverture pour ne pas déranger vos opérations.",
      },
      {
        q: "Pellicule miroir ou givrée pour mon rez-de-chaussée ?",
        a: "Le miroir garde votre vue vers l'extérieur le jour ; la givrée assure une intimité totale jour et nuit. On vous conseille pièce par pièce, selon l'orientation de vos fenêtres.",
      },
    ],
    brossard: [
      {
        q: "Faites-vous les nouvelles constructions à Brossard ?",
        a: "Oui. Les grandes fenêtres des constructions récentes sont parmi celles qui profitent le plus de la pellicule : moins de chaleur, moins d'éblouissement et une protection contre les UV dès le premier jour.",
      },
      {
        q: "Combien de temps prend l'installation ?",
        a: "La plupart des résidences sont complétées en une seule journée, avec une finition propre et sans bulles. Après une cure d'environ 30 jours, l'entretien se fait normalement.",
      },
    ],
    montreal: [
      {
        q: "Faites-vous l'installation dans les condos et les immeubles de Montréal ?",
        a: "Oui. Nous installons dans les maisons, condos, duplex et immeubles commerciaux de Montréal. Chaque fenêtre est évaluée avant la pose, et notre service clé en main est propre et sans dégât.",
      },
      {
        q: "L'estimation est-elle vraiment gratuite à Montréal ?",
        a: "Oui. Vous remplissez le formulaire ou vous nous appelez, et un membre de l'équipe vous contacte sous 24 à 48 heures avec un prix clair, sans engagement.",
      },
      {
        q: "Quelle pellicule convient à un logement face à la rue ?",
        a: "La pellicule miroir bloque les regards de jour tout en gardant votre vue vers l'extérieur. Si la pièce exige une intimité jour et nuit, salle de bain ou chambre au rez-de-chaussée, la pellicule givrée est le meilleur choix. On vous conseille selon l'orientation de vos fenêtres.",
      },
    ],
    "rive-nord": [
      {
        q: "Desservez-vous ma ville sur la Rive-Nord ?",
        a: "Nous desservons la Rive-Nord, de Laval à Terrebonne et les environs. Écrivez-nous pour confirmer votre secteur, l'estimation reste gratuite.",
      },
      {
        q: "Les portes-patio et vérandas peuvent-elles être traitées ?",
        a: "Oui. Les portes-patio, vérandas et solariums sont parmi les surfaces les plus traitées : ce sont souvent elles qui laissent entrer le plus de chaleur l'été. Chaque vitrage est évalué avant la pose.",
      },
      {
        q: "Combien de temps prend une installation résidentielle ?",
        a: "La plupart des résidences sont complétées en une seule journée, avec une finition propre et sans bulles.",
      },
    ],
    "rive-sud": [
      {
        q: "Desservez-vous Longueuil et Brossard ?",
        a: "Oui, nous desservons la Rive-Sud, de Longueuil à Brossard et les environs. Écrivez-nous pour confirmer votre secteur, l'estimation est gratuite.",
      },
      {
        q: "La pellicule aide-t-elle contre l'éblouissement sur les écrans ?",
        a: "Oui. Nos pellicules réduisent l'éblouissement de façon marquée, de 62 à 82 % selon la teinte, ce qui rend les écrans d'ordinateur et les téléviseurs beaucoup plus confortables, sans fermer les rideaux.",
      },
      {
        q: "L'estimation à domicile est-elle sans engagement ?",
        a: "Oui. L'estimation est 100 % gratuite et sans engagement : on mesure, on évalue l'exposition, puis on vous donne un prix clair.",
      },
    ],
  },
  en: {
    laval: [
      {
        q: "Do you serve all Laval neighbourhoods?",
        a: "Yes, we install everywhere in Laval, bungalows, condos, waterfront properties and businesses. The estimate is free and commitment-free, anywhere in the city.",
      },
      {
        q: "Do you work in condominium buildings?",
        a: "Yes. We install in condos as well as houses. Every window is assessed before installation to confirm glazing compatibility, and our turnkey service is clean and mess-free.",
      },
      {
        q: "Which film for a house that overheats in summer?",
        a: "Mirror film rejects up to 83% of solar heat and protects against UV rays, while keeping the light. We assess each window's exposure during the free estimate to pick the right shade.",
      },
    ],
    longueuil: [
      {
        q: "Is the estimate free in Longueuil?",
        a: "Yes, everywhere in Longueuil: fill out the form or call us, and a team member replies within 24 to 48 hours with a clear price, no commitment.",
      },
      {
        q: "Do you also work for Longueuil businesses?",
        a: "Yes, residential and commercial. For shops and offices, installation can be scheduled outside your opening hours so your operations are not disrupted.",
      },
      {
        q: "Mirror or frosted film for my ground floor?",
        a: "Mirror keeps your outward view by day; frosted provides total privacy day and night. We advise you room by room, based on your windows' orientation.",
      },
    ],
    brossard: [
      {
        q: "Do you work on new constructions in Brossard?",
        a: "Yes. The large windows of recent constructions are among those that benefit most from film: less heat, less glare and UV protection from day one.",
      },
      {
        q: "How long does installation take?",
        a: "Most homes are completed in a single day, with a clean, bubble-free finish. After a curing period of about 30 days, maintenance is done as usual.",
      },
    ],
    montreal: [
      {
        q: "Do you install in Montreal condos and apartment buildings?",
        a: "Yes. We install in houses, condos, duplexes and commercial buildings across Montreal. Every window is assessed before installation, and our turnkey service is clean and mess-free.",
      },
      {
        q: "Is the estimate really free in Montreal?",
        a: "Yes. Fill out the form or call us, and a team member contacts you within 24 to 48 hours with a clear price, no commitment.",
      },
      {
        q: "Which film is right for a home facing the street?",
        a: "Mirror film blocks daytime gazes while keeping your outward view. If the room needs day-and-night privacy, a bathroom or ground-floor bedroom, frosted film is the best choice. We advise you based on your windows' orientation.",
      },
    ],
    "rive-nord": [
      {
        q: "Do you serve my city on the North Shore?",
        a: "We serve the North Shore, from Laval to Terrebonne and the surrounding area. Write to us to confirm your area, the estimate stays free.",
      },
      {
        q: "Can patio doors and verandas be treated?",
        a: "Yes. Patio doors, verandas and solariums are among the most treated surfaces: they're often the ones letting in the most heat in summer. Every glazing is assessed before installation.",
      },
      {
        q: "How long does a residential installation take?",
        a: "Most homes are completed in a single day, with a clean, bubble-free finish.",
      },
    ],
    "rive-sud": [
      {
        q: "Do you serve Longueuil and Brossard?",
        a: "Yes, we serve the South Shore, from Longueuil to Brossard and the surrounding area. Write to us to confirm your area, the estimate is free.",
      },
      {
        q: "Does the film help against glare on screens?",
        a: "Yes. Our films reduce glare dramatically, by 62 to 82% depending on the shade, making computer screens and TVs far more comfortable, without closing the curtains.",
      },
      {
        q: "Is the at-home estimate really no-commitment?",
        a: "Yes. The estimate is 100% free with no commitment: we measure, assess the exposure, then give you a clear price.",
      },
    ],
  },
};

// Liens vers les pages de services (réutilisés dans le pied de page et les pages villes)
export const serviceLinks = {
  fr: [
    { to: "/pellicule-miroir", label: "Pellicule miroir" },
    { to: "/pellicule-anti-chaleur", label: "Pellicule anti-chaleur" },
    { to: "/pellicule-anti-uv", label: "Pellicule anti-UV" },
    { to: "/pellicule-intimite-fenetre", label: "Pellicule d'intimité" },
    { to: "/pellicule-givree", label: "Pellicule givrée" },
  ],
  en: [
    { to: "/pellicule-miroir", label: "Mirror window film" },
    { to: "/pellicule-anti-chaleur", label: "Heat control film" },
    { to: "/pellicule-anti-uv", label: "UV protection film" },
    { to: "/pellicule-intimite-fenetre", label: "Privacy window film" },
    { to: "/pellicule-givree", label: "Frosted window film" },
  ],
};

export const serviceLinksTitle = { fr: "Nos pellicules", en: "Our window films" };
export const cityServicesTitle = { fr: "Nos pellicules par besoin", en: "Our films by need" };
export const cityFaqTitle = { fr: "Questions fréquentes dans votre secteur", en: "Local questions, answered" };

// Titre d'onglet propre par ville (le H1 reste « Installation de pellicule… »)
export const cityMetaTitles = {
  fr: {
    montreal: "Pellicule pour fenêtres à Montréal | Reflectum Pellicule",
    laval: "Pellicule pour fenêtres à Laval | Reflectum Pellicule",
    longueuil: "Pellicule pour fenêtres à Longueuil | Reflectum Pellicule",
    brossard: "Pellicule pour fenêtres à Brossard | Reflectum Pellicule", "rive-nord": "Pellicule pour fenêtres Rive-Nord | Reflectum Pellicule", "rive-sud": "Pellicule pour fenêtres Rive-Sud | Reflectum Pellicule",
  },
  en: {
    montreal: "Window Film Installation Montreal | Reflectum Pellicule",
    laval: "Window Film Installation Laval | Reflectum Pellicule",
    longueuil: "Window Film Installation Longueuil | Reflectum",
    brossard: "Window Film Installation Brossard | Reflectum Pellicule", "rive-nord": "Window Film Installation North Shore | Reflectum", "rive-sud": "Window Film Installation South Shore | Reflectum",
  },
};
